__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/0dfea38/_next/";